import { CitiesResponse } from '../../models/cities-response.model';
import { Observable, of } from 'rxjs';

export class TypeListServiceStub {
    getCitiesByPostalCode(postalCode: string, countryCode: string = 'ar'): Observable<CitiesResponse> {
        return of({
            cities: [{
                name: 'Rosario',
                stateCode: '',
                stateDescription: '',
                synonymous: ''
             }]});
    }
}
